import SearchingChild from "../containers/SearchingChild";

function SearchElement() {
  return <SearchingChild />;
}

export default SearchElement;
